import { CSSProperties } from 'react';

export const containerStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  margin: '0 auto'
};

export const labelStyle: CSSProperties = {
  fontSize: '14px',
  color: '#666'
};

export const valueStyle: CSSProperties = {
  fontSize: '14px',
  fontWeight: 'bold'
};

export const sliderWrapperStyle: CSSProperties = {
  width: '100%',
  margin: '0 auto',
  padding: '20px 0'
};

export const trackContainerStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  paddingTop: 10
};

export const thumbSpacingStyle = (thumbRadius: number): CSSProperties => ({
  height: '1px',
  width: `${thumbRadius}px`,
  backgroundColor: '#ccc',
  flexShrink: 0
});

export const trackStyle = (background: string): CSSProperties => ({
  height: '1px',
  width: '100%',
  background
});

export const thumbStyle = (thumbRadius: number): CSSProperties => ({
  height: `${thumbRadius * 2}px`,
  width: `${thumbRadius * 2}px`,
  backgroundColor: 'white',
  border: '1px solid black',
  borderRadius: '50%',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
  outline: 'none',
  cursor: 'pointer'
});

export const thumbTransform = (index: number): CSSProperties => ({
  transform: index === 0 ? 'translateX(-50%)' : 'translateX(50%)'
});
